var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'section-assign',
    'flex',
    _vm.assign === 'left' ? 'leftToRight' : 'rightToLeft' ]},[_c('div',{staticClass:"left flex"},[_c('div',{staticClass:"left-content flex"},[_vm._t("tips"),_vm._t("title"),_vm._t("des"),_vm._t("btn"),_vm._t("default")],2)]),_c('div',{staticClass:"right"},[(_vm.bgSrc)?_c('el-image',{attrs:{"src":_vm.bgSrc,"fit":"cover"}}):_vm._e(),_vm._t("swiper")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }